module.exports = __webpack_public_path__ + "static/img/mc15k_1.b3e528f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mc15k_1.png
// module id = 2cQ/
// module chunks = 16